import {
  CREDENTIALS_REQUEST_BASE_URL, CREDENTIALS_REQUEST_VERIFY_BASE_URL,
  // CREDENTIALS_REQUEST_VERIFY_BASE_URL
} from "./config";
import axios from "axios";

export async function credentialsRequest(data) {
  return axios.post(CREDENTIALS_REQUEST_BASE_URL, data);
}

export async function verifyMobile(data) {
  return axios.post(CREDENTIALS_REQUEST_VERIFY_BASE_URL, data);
}